import { type QuestionProperties, type QBankStructureDashboardData } from '../../types';

import { getTotalQuestionCount } from './get-total-question-count';

type DifficultyCount = Record<'hardQuestions' | 'mediumQuestions' | 'easyQuestions', number>;

const DIFFICULTY_KEYS: (keyof DifficultyCount)[] = [
  'hardQuestions',
  'mediumQuestions',
  'easyQuestions',
];
const CATEGORY_KEYS: (keyof QuestionProperties)[] = ['calculate', 'nonCalculate'];

function sumDifficulty(
  target: DifficultyCount,
  source: Partial<Record<keyof DifficultyCount, number | null>> | undefined,
) {
  for (const key of DIFFICULTY_KEYS) {
    target[key] += source?.[key] ?? 0;
  }
}

function formatDifficultyCount(
  input: Partial<Record<keyof DifficultyCount, number | null>> | undefined,
) {
  return {
    hardQuestions: input?.hardQuestions || null,
    mediumQuestions: input?.mediumQuestions || null,
    easyQuestions: input?.easyQuestions || null,
  };
}

export function getCalculateAndNonCalculateTotalFromLOSRow(
  row: QBankStructureDashboardData,
  losRows: QBankStructureDashboardData[],
) {
  const questionProperty: Record<keyof QuestionProperties, DifficultyCount> = {
    calculate: { hardQuestions: 0, mediumQuestions: 0, easyQuestions: 0 },
    nonCalculate: { hardQuestions: 0, mediumQuestions: 0, easyQuestions: 0 },
  };

  const childRows = losRows.filter((losRow) => losRow.parentIds.includes(row.id));

  for (const losRow of childRows) {
    for (const category of CATEGORY_KEYS) {
      sumDifficulty(questionProperty[category], losRow[category]);
    }
  }

  const formattedQuestionProperty: QuestionProperties = {
    calculate: formatDifficultyCount(questionProperty.calculate),
    nonCalculate: formatDifficultyCount(questionProperty.nonCalculate),
  };

  return { ...formattedQuestionProperty, total: getTotalQuestionCount(formattedQuestionProperty) };
}
